import { Tab, TextField } from "react-admin";

const TabAdminNotes = (props) => (
  <Tab label="Admin Notes" {...props}>
    <TextField source="adminNotes" label="Admin Notes" />
  </Tab>
);

export default TabAdminNotes;
